var map = {
	"./banners/hero-bg.png": 9971,
	"./banners/popular-game-bg.png": 2825,
	"./banners/register-banner.png": 9909,
	"./banners/sports-bg1.png": 8847,
	"./banners/sports-bg2.png": 8932,
	"./games/game1.png": 7012,
	"./games/game2.png": 9471,
	"./games/game3.png": 726,
	"./games/game4.png": 9353,
	"./games/game5.png": 3600,
	"./games/game6.png": 9003,
	"./icons/announcement.png": 7787,
	"./icons/avatar.png": 8589,
	"./icons/crumb-back.svg": 7197,
	"./icons/crumb-home.svg": 2177,
	"./icons/crumb-refresh.svg": 7117,
	"./icons/favourites-icon.png": 4210,
	"./icons/icon-birthday.png": 9231,
	"./icons/icon-email.png": 14,
	"./icons/icon-lock.png": 8829,
	"./icons/icon-name.png": 5097,
	"./icons/icon-phone.png": 3430,
	"./icons/nav-login.png": 6379,
	"./icons/nav-member.png": 1776,
	"./icons/nav-promotion.png": 5771,
	"./icons/no_item.png": 9441,
	"./icons/shortcut-deposit.png": 5501,
	"./icons/shortcut-referrer.png": 8934,
	"./icons/shortcut-reward.png": 4330,
	"./icons/shortcut-support.png": 9002,
	"./icons/shortcut-vip.png": 6486,
	"./icons/shortcut-withdrawal.png": 122,
	"./icons/wallet-icon.png": 1455,
	"./icons/wallet.png": 2897,
	"./menu/arcade.png": 7587,
	"./menu/bingo.png": 1606,
	"./menu/cockfight.png": 281,
	"./menu/fish.png": 525,
	"./menu/home.png": 7990,
	"./menu/hot.png": 7746,
	"./menu/instwin.png": 4513,
	"./menu/live.png": 7541,
	"./menu/livegrand.png": 2923,
	"./menu/lottery.png": 5352,
	"./menu/member.png": 5453,
	"./menu/mini.png": 6022,
	"./menu/poker.png": 3292,
	"./menu/pop.png": 430,
	"./menu/promotion.png": 8864,
	"./menu/rng.png": 6372,
	"./menu/slots.png": 7596,
	"./menu/sport.png": 7469,
	"./menu/table.png": 4135,
	"./misc/dow-android.png": 1514,
	"./misc/dow-ios.png": 2696,
	"./misc/logo.png": 5269,
	"./misc/qr.png": 8005,
	"./payment/pay16.png": 7363,
	"./payment/pay17.png": 5450,
	"./payment/pay18.png": 2573,
	"./payment/pay19.png": 1444,
	"./payment/pay20.png": 368,
	"./payment/pay21.png": 8489,
	"./payment/pay46.png": 3840,
	"./promotions/promo-1.png": 7803,
	"./social/facebook.png": 6019,
	"./social/line.png": 4625,
	"./social/telegram.png": 6342,
	"./social/twitter.png": 3229,
	"./social/wechat.png": 5789,
	"./social/whatsapp.png": 2189,
	"./vendors/100HP.png": 3074,
	"./vendors/AA.png": 9001,
	"./vendors/ALG.png": 9417,
	"./vendors/ALGM.png": 7320,
	"./vendors/AMBS.png": 9728,
	"./vendors/AMUSNET.png": 1236,
	"./vendors/AP.png": 5408,
	"./vendors/AVATARUX.png": 2791,
	"./vendors/AVIA.png": 1944,
	"./vendors/AVIATOR.png": 8865,
	"./vendors/BGL.png": 2508,
	"./vendors/BNG.png": 6636,
	"./vendors/CF6.png": 3312,
	"./vendors/CG.png": 9461,
	"./vendors/COSMO.png": 5982,
	"./vendors/CPG.png": 639,
	"./vendors/CQ9.png": 7610,
	"./vendors/DB.png": 9125,
	"./vendors/DBLIVE.png": 3899,
	"./vendors/DG.png": 2971,
	"./vendors/ENDOR.png": 8487,
	"./vendors/EVOBTG.png": 3118,
	"./vendors/EVOLIVE.png": 5761,
	"./vendors/EVONLC.png": 5214,
	"./vendors/EVONTT.png": 5305,
	"./vendors/EVOP.png": 4103,
	"./vendors/EVORT.png": 4581,
	"./vendors/EW.png": 8691,
	"./vendors/EZUGI.png": 3113,
	"./vendors/FC.png": 1370,
	"./vendors/GPK7MJ.png": 1221,
	"./vendors/GPKBG.png": 1182,
	"./vendors/GPKBM.png": 4404,
	"./vendors/GPKICONIC.png": 5284,
	"./vendors/GPKPNG.png": 8290,
	"./vendors/GPKSPINO.png": 5800,
	"./vendors/GPKTBG.png": 2098,
	"./vendors/HB.png": 9761,
	"./vendors/HSD.png": 2414,
	"./vendors/INOUT.png": 1728,
	"./vendors/JDB-GTF.png": 9269,
	"./vendors/JDB.png": 2047,
	"./vendors/JL.png": 9841,
	"./vendors/KYP.png": 6843,
	"./vendors/LIVE22.png": 2369,
	"./vendors/LT.png": 5563,
	"./vendors/LUCKY365.png": 9355,
	"./vendors/MG.png": 5387,
	"./vendors/MTL.png": 3598,
	"./vendors/PC.png": 6048,
	"./vendors/PGS.png": 3573,
	"./vendors/PNG.png": 33,
	"./vendors/POKER365.png": 6202,
	"./vendors/PP.png": 3243,
	"./vendors/PT.png": 6239,
	"./vendors/QM.png": 5765,
	"./vendors/RG.png": 6010,
	"./vendors/SABA.png": 52,
	"./vendors/SBG.png": 837,
	"./vendors/SGPT.png": 6353,
	"./vendors/SPB.png": 7986,
	"./vendors/SPDG.png": 8817,
	"./vendors/SSG.png": 7386,
	"./vendors/TBGAMES.png": 576,
	"./vendors/TBP.png": 5777,
	"./vendors/TD.png": 7747,
	"./vendors/TK.png": 3876,
	"./vendors/VPLUS.png": 1785,
	"./vendors/WAZDAN.png": 9636,
	"./vendors/WCBTG.png": 1912,
	"./vendors/WCLIVE.png": 355,
	"./vendors/WCNLC.png": 5848,
	"./vendors/WCNTT.png": 863,
	"./vendors/WCRT.png": 1975,
	"./vendors/WCWF.png": 2658,
	"./vendors/WIFY.png": 9156,
	"./vendors/WMLIVE.png": 2245,
	"./vendors/YB.png": 3242,
	"./vendors/YBNGO.png": 9436,
	"./vendors/YH998.png": 9176,
	"./vendors/banners/1.png": 5314,
	"./vendors/banners/2.png": 457,
	"./vendors/banners/3.png": 5632,
	"./vendors/banners/4.png": 4287,
	"./vendors/banners/5.png": 3817,
	"./vendors/banners/6.png": 6877
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7295;